// import { BrowserRouter, Route, Routes } from "react-router-dom";
// unod this and your back
import { createContext, useEffect, useState } from "react";
import "./App.css";
import AdminNavbar from "./Components/Admin/AdminNavbar";
import useUtmTracker from "./hooks/useUtmTracker"; // Import the custom UTM tracker hook
// import server from "./Components/server";
import { Box } from "@mui/material";
import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DashboardState from "./Components/Admin/Context/DashboardState";

//client imports
import Navbar from "./Components/User/Navbar/Navbar";
// import { Route, Routes } from "react-router-dom";
import AddAddress from "./Components/User/AddAddress/AddAddress";
import Cart from "./Components/User/Cart/Cart";
import Category from "./Components/User/Category/Category";
import CategoryProducts from "./Components/User/CategoryProducts/CategoryProducts";
import Home from "./Components/User/Home/Home";
import MyAddress from "./Components/User/MyAddress/MyAddress";
import Notification from "./Components/User/Notification/Notification";
import OrderAcceptedPage from "./Components/User/OrderAccepted/OrderAcceptedPage";
import Orders from "./Components/User/Orders/Orders";
import PlaceOrder from "./Components/User/PlaceOrder/PlaceOrder";
import ProductDetails from "./Components/User/ProductDetails/ProductDetails";
import Profile from "./Components/User/Profile/Profile";
import ReturnOrder from "./Components/User/ReturnOrder/ReturnOrder";
import ReviewPage from "./Components/User/ReviewPage/ReviewPage";
import Search from "./Components/User/Search/Search";
import ShoppingCart from "./Components/User/ShoppingCart/ShoppingCart";
import SubCategory from "./Components/User/SubCategory/SubCateogry";
import TrackOrder from "./Components/User/TrackOrder/TrackOrder";
import Wishlist from "./Components/User/Wishlist/Wishlist";
import WriteReviewPage from "./Components/User/WriteReviewPage/WriteReviewPage";
// import Verification from "./Verification";
import EditAddress from "./Components/User/EditAddress/EditAddress";
import { NavBarContext } from "./Components/User/Navbar/Navbar";
import ViewOrder from "./Components/User/ViewOrderDetails/ViewOrder";
import ViewReturnOrder from "./Components/User/ViewReturnOrder/ViewReturnOrder";

import PrivateRoute from "./Components/PrivateRoute/PrivateRoute";
import InvalidPincode from "./Components/User/InvalidPincode/InvalidPincode";
// import EditProduct from "./Components/Admin/Inventory/Layout/EditProductForm";
// import Contact from "./Components/User/Contact/About";
import Contact from "./Components/User/Info/Contact";

import axios from "axios";
import { useDispatch } from "react-redux";
import { eAppLaunch } from "./analytics/logEvent";
import Login from "./Components/Admin/Login";
import PrivateLogin from "./Components/PrivateRoute/PrivateLogin";
import server from "./Components/server";
import PostDeliveryFeedback from "./Components/User/Campaigns/PostDeliveryFeedback";
import RecentOrders from "./Components/User/CategoryProducts/RecentOrders";
import About from "./Components/User/Info/About";
import Privacy from "./Components/User/Info/Privacy";
import RefundPolicy from "./Components/User/Info/RefundPolicy/RefundPolicy";
import ShippingPolicy from "./Components/User/Info/ShippingPolicy/ShippingPolicy";
import TermsAndConditions from "./Components/User/Info/TAndC";
import FeedbackSuccess from "./Components/User/Loader/FeedBackSuccess";
import SubcategoryPage from "./Components/User/SubCategoryPage/SubCategoryPage";
import UserLogin from "./Components/User/UserLogin";
import { clearState } from "./redux/slices/dataSlice";

export const UserContext = createContext();

function App() {
  useUtmTracker(); // Call the custom hook once on initial render
  const navigate = useNavigate();
  const [user, setUser] = useState(false);
  const [client, setClient] = useState(false);
  const [profileopen, setProfileopen] = useState(false);
  const [items, setItems] = useState(0); // for client side
  const [note, setNote] = useState(""); // for client side
  const [wishList, setWishList] = useState([]);
  const [quickCommerce, setQuickCommerce] = useState(false);
  const location = useLocation();
  const dispatch = useDispatch();

  const reset = () => {
    console.log("reseting");
    const cartprice = Number(localStorage.getItem("cartprice")); // Convert to number
    const cart = localStorage.getItem("cart");
    if (Number.isNaN(cartprice)) {
      // Check if cartprice is NaN
      localStorage.setItem("cartprice", 0);
      localStorage.setItem("cart", JSON.stringify([]));
      dispatch(clearState());
    }
  };

  useEffect(() => {
    const checkPendingTransaction = async () => {
      const txnId = localStorage.getItem("txnId");
      const accessToken = localStorage.getItem("accessToken");

      if (txnId && accessToken) {
        try {
          const response = await axios.get(`${server}/status/${txnId}`, {
            headers: { Authorization: `Bearer ${accessToken}` },
          });

          if (response.data.data?.state === "COMPLETED") {
            navigate(`/placeorder?payment_redirect=true`, { replace: true });
          }
        } catch (error) {
          console.error("Transaction check failed:", error);
        }
      }
    };

    checkPendingTransaction();
  }, []);

  useEffect(() => {
    reset();
  }, []);

  useEffect(() => {
    if (localStorage.getItem("adminuser")) {
      setUser(true);
    } else if (localStorage.getItem("user")) {
      setClient(true);
    } else setClient(false);
    // else setClient(true);
    if (!localStorage.getItem("cart") && !localStorage.getItem("cartprice")) {
      localStorage.setItem("cart", JSON.stringify([]));
      localStorage.setItem("cartprice", 0);
    }
  }, []);

  function isMobileBrowser() {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    return (
      true ||
      /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
        userAgent,
      )
    );
    // return true;
  }

  const [s3, setS3] = useState();

  const fetchWishList = async () => {
    // console.log(localStorage.getItem('user'))
    const result = await axios.get(
      `${server}/user/wishlist/status/${localStorage.getItem("user")}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      },
    );
    result.data[0]?.productList && setWishList(result.data[0].productList);
  };

  const requestOptions = {
    headers: {
      method: "GET",
      Authorization: `Bearer ${localStorage.getItem("access")}`,
    },
  };
  useEffect(() => {
    eAppLaunch();
    localStorage.getItem("accessToken") && fetchWishList();
  }, []);

  return (
    <>
      {localStorage.getItem("adminuser") ? (
        <div className="App">
          <UserContext.Provider value={{ user, setUser }}>
            <DashboardState>
              <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
              />
              <AdminNavbar setOpen={setProfileopen} />
              {/* <Profileupdate open={profileopen} setOpen={setProfileopen} /> */}
              <Box sx={{ display: "flex" }} className="test">
                {/* <DrawerHeader /> */}

                {/* <Route path="/viewproduct" element={<ViewProduct />} /> */}
                {/* <Route path="/viewcustomer" element={<CustomerOrder />} /> */}
                {/* <Route path="/content" element={<Content />} /> */}
                {/* <Route path="/pincodelist" element={<PinCodeList />} /> */}
                {/* <Route path="/viewusernetwork" element={<ViewUserNetwork />} /> */}
              </Box>
            </DashboardState>
          </UserContext.Provider>
        </div>
      ) : true ? (
        isMobileBrowser() ? (
          <Box className="App">
            <NavBarContext.Provider
              value={{
                items,
                setItems,
                client,
                setClient,
                note,
                setNote,
                s3,
                wishList,
                fetchWishList,
                quickCommerce,
                setQuickCommerce,
              }}
            >
              <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
              />
              {location.pathname !== "/cart" &&
                !["/admin/login", "/login", "/placeorder"].includes(
                  location.pathname,
                ) && <Navbar />}
              <Routes>
                <Route path="/" element={<Navigate to="/home" replace />} />
                <Route path="/login" element={<UserLogin />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/about" element={<About />} />
                <Route path="/privacy" element={<Privacy />} />{" "}
                <Route path="/tnc" element={<TermsAndConditions />} />
                <Route path="/refund-policy" element={<RefundPolicy />} />
                <Route
                  path="/shipping-policy"
                  element={<ShippingPolicy />}
                ></Route>
                {isMobileBrowser() && <> </>}
                <Route
                  path="/login"
                  element={
                    <PrivateLogin>
                      <UserLogin />
                    </PrivateLogin>
                  }
                />
                <Route
                  path="/admin/login"
                  element={
                    <PrivateLogin>
                      <Login />
                    </PrivateLogin>
                  }
                />
                {/* <Route path="/login" element={
            <PrivateLogin>
            <UserLogin />
            </PrivateLogin>
            } /> */}
                {/* <Route path="/verification" element={<Verification />} /> */}
                <Route
                  index
                  path="/home"
                  element={
                    // <PrivateRoute>
                    <Home />
                    // </PrivateRoute>
                  }
                />
                <Route
                  path="/orders/recent/:name"
                  element={
                    <PrivateRoute>
                      <RecentOrders />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/category"
                  element={
                    // <PrivateRoute>
                    <Category />
                    // </PrivateRoute>
                  }
                />
                <Route
                  path="/subcategory/:catid"
                  element={
                    // <PrivateRoute>
                    <SubCategory />
                    // </PrivateRoute>
                  }
                />
                <Route
                  path="/subcategoryPage/:name"
                  element={<SubcategoryPage />}
                />
                <Route
                  path="/cart"
                  element={
                    // <PrivateRoute>
                    <Cart />
                    // </PrivateRoute>
                  }
                />
                <Route
                  // path="/categoryproducts/:name/:catid/:categoryId"
                  path="/categoryproducts/:name/:subcatname"
                  element={
                    // <PrivateRoute>
                    <CategoryProducts />
                    // </PrivateRoute>
                  }
                />
                <Route
                  path="/productdetail/:prodid"
                  element={
                    // <PrivateRoute>
                    <ProductDetails />
                    // </PrivateRoute>
                  }
                />
                <Route
                  path="/review/:prodid"
                  element={
                    // <PrivateRoute>
                    <ReviewPage />
                    // </PrivateRoute>
                  }
                />
                <Route
                  path="/writereview/:prodid"
                  element={
                    <PrivateRoute>
                      <WriteReviewPage />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/placeorder"
                  element={
                    <PrivateRoute>
                      <PlaceOrder />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/orderplaced/:status/:orderId"
                  element={
                    <PrivateRoute>
                      <OrderAcceptedPage />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/trackorder/:orderId"
                  element={
                    <PrivateRoute>
                      <TrackOrder />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/cartempty"
                  element={
                    <PrivateRoute>
                      <ShoppingCart />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/profile"
                  element={
                    <PrivateRoute>
                      <Profile />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/wishlist"
                  element={
                    <PrivateRoute>
                      <Wishlist />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/myaddress"
                  element={
                    // <PrivateRoute>
                    <MyAddress />
                    // </PrivateRoute>
                  }
                />
                <Route
                  path="/addaddress"
                  element={
                    // <PrivateRoute>
                    <AddAddress />
                    // </PrivateRoute>
                  }
                />
                <Route
                  path="/editaddress/:addid"
                  element={
                    // <PrivateRoute>
                    <EditAddress />
                    // </PrivateRoute>
                  }
                />
                <Route
                  path="/notification"
                  element={
                    <PrivateRoute>
                      <Notification />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/client/orders"
                  element={
                    <PrivateRoute>
                      <Orders />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/returnorder/:orderId"
                  element={
                    <PrivateRoute>
                      <ReturnOrder />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/returnorder/view/:returnId"
                  element={
                    <PrivateRoute>
                      <ViewReturnOrder />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/vieworder/:orderId"
                  element={
                    <PrivateRoute>
                      <ViewOrder />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/cancel/:orderId"
                  element={
                    <PrivateRoute>
                      <ViewOrder pageType={"cancelOrder"} />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/search"
                  element={
                    // <PrivateRoute>
                    <Search />
                    // </PrivateRoute>
                  }
                />
                <Route
                  path="/invalidpincode"
                  element={
                    <PrivateRoute>
                      <InvalidPincode />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/campaign/ordercomplete"
                  element={
                    <PrivateRoute>
                      <PostDeliveryFeedback />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/campaign/feedback-success"
                  element={
                    <PrivateRoute>
                      <FeedbackSuccess />
                    </PrivateRoute>
                  }
                />
                {/* <Route
                  path="/*"
                  element={
                    <PrivateRoute>
                      <Home />
                    </PrivateRoute>
                  }
                /> */}
              </Routes>
            </NavBarContext.Provider>
          </Box>
        ) : (
          <></>
        )
      ) : (
        <>
          <Box className="App">
            {" "}
            <NavBarContext.Provider
              value={{ items, setItems, client, setClient }}
            >
              <UserContext.Provider value={{ user, setUser }}>
                <DashboardState>
                  <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="light"
                  />
                  <Box sx={{ display: "flex" }}>
                    <Routes>
                      {" "}
                      <Route
                        path="/admin/login"
                        element={
                          <PrivateLogin>
                            <Login />
                          </PrivateLogin>
                        }
                      />{" "}
                      <Route path="/contact" element={<Contact />} />
                      <Route path="/about" element={<About />} />
                      <Route path="/privacy" element={<Privacy />} />{" "}
                      <Route path="/tnc" element={<TermsAndConditions />} />
                      <Route path="/refund-policy" element={<RefundPolicy />} />
                      <Route
                        path="/shipping-policy"
                        element={<ShippingPolicy />}
                      ></Route>
                      {isMobileBrowser() && <> </>}
                      <Route
                        path="/login"
                        element={
                          <PrivateLogin>
                            <UserLogin />
                          </PrivateLogin>
                        }
                      />
                      {/* <Route path="*" element={<Navigate to="/login" />} /> */}
                      {/* <Route
                        path="*"
                        element={
                          <>
                            <div className="fallback_page">
                              <img src="/ms-icon-310x310.png" alt="" />
                              <div>
                                Welcome! For the optimal experience, please
                                access our site using a mobile device.
                              </div>
                            </div>
                          </>
                        }
                      /> */}
                    </Routes>
                  </Box>
                </DashboardState>
              </UserContext.Provider>{" "}
            </NavBarContext.Provider>
          </Box>{" "}
        </>
      )}
    </>
  );
}

export default App;
